export default "__VITE_PUBLIC_ASSET__75898664__"